import { render, staticRenderFns } from "./ReversionDetallePage.vue?vue&type=template&id=9cd9e4c0"
import script from "./ReversionDetallePage.js?vue&type=script&lang=js&external"
export * from "./ReversionDetallePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports